<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      size="small"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="
              this.$l('form_label_mrpOtherStockOutNo') || '其他入库单编码'
            "
            prop="mrpOtherStockOutNo"
          >
            <el-input
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              readonly
              v-model="formData.mrpOtherStockOutNo"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_stockOutType') || '入库类型'"
            prop="stockOutType"
          >
            <dict-select
              clearable
              v-model="formData.stockOutType"
              :body="stockOutTypeParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              size="small"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_warehouseName') || '入库仓库'"
            prop="warehouseCode"
          >
            <dict-select
              clearable
              v-model="formData.warehouseCode"
              :selectedLabel.sync="formData.warehouseName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              size="small"
              url="/ecom/warehouse/cn/warehouse/select"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_stockOutDate') || '入库日期'">
            <el-date-picker
              v-model="formData.stockOutDate"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="this.$l('form_label_remark') || '备注'"
            prop="remark"
          >
            <el-input
              type="textarea"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.remark"
              :rows="2"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <StockDetailTable
      :tableData="detailList"
      :disabled="disabled"
      ref="stockDetailTable"
      @updateTableData="updateTableData"
    >
      <template v-slot:header>
        <div class="d-flex mt-2">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">
              {{ $l('form_label_add_stock') || '添加明细' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="mini"
              type="primary"
              plain
              :disabled="disabled"
              @click="openChooseMaterial"
            >
              {{ $l('INDEX.btn_add') || '新增' }}
            </el-button>
          </div>
        </div>
      </template>
    </StockDetailTable>
    <ChooseMaterialBatch
      :visible.sync="chooseMaterialVisible"
      multiple
      confirm-on-close
      reserve
      :url="'/factory/fty/material/batch/list'"
      @confirm="chooseMaterialConfirm"
    >
    </ChooseMaterialBatch>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import StockDetailTable from './stock-detail-table.vue'
import ChooseMaterialBatch from '@/views/factory/inventory/components/choose-material-batch'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    mrpOtherStockOutCode: String,
  },
  components: { StockDetailTable, ChooseMaterialBatch },
  data() {
    return {
      formData: { cancelReason: '' },
      stockOutTypeParams: { dictType: 'stockOutType' },
      reasonVisible: false,
      chooseMaterialVisible: false,
      detailList: [],
      rules: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.mrpOtherStockOutCode) return
      this.loadingOpen()
      this.$api
        .mrpOtherStockOutDetailApi({
          mrpOtherStockOutCode: this.mrpOtherStockOutCode,
        })
        .then((res) => {
          this.loadingClose()
          this.formData = res.body
          this.detailList = res.body.detailList || []
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }

      this.loadingOpen()
      this.$api
        .mrpOtherStockOutSaveApi({
          mrpOtherStockOutCode: this.mrpOtherStockOutCode,
          detailSaveList: this.$refs.stockDetailTable.getTableData(),
          ...this.formData,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status == 200) {
            this.$message({
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success',
            })
            this.$emit('close')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    saveOkQuestion() {
      this.$emit('saveOkQuestion')
    },
    openChooseMaterial() {
      this.chooseMaterialVisible = true
    },
    updateTableData(data) {
      this.detailList = data || []
    },
    chooseMaterialConfirm(data) {
      if (data && data.length) {
        const tmpDetailList = []
        if (!data || !data.length) return
        const tableData = this.$refs.stockDetailTable.getTableData()
        if (tableData && tableData.length) {
          data = data.filter(
            (i) =>
              !tableData
                .map((j) => j.materialCode)
                .includes(i.materialBatchCode)
          )
        }
        if (!data || !data.length) return

        data.forEach((e) => {
          tmpDetailList.push({
            sourceBillNo: '',
            materialType: e.materialBatchType,
            materialTypeText: e.materialBatchTypeText,
            materialCode: e.materialBatchCode,
            materialNo: e.materialBatchNo,
            materialName: e.materialBatchName,
            materialSpec: e.materialBatchSpec,
            materialUnit: e.materialBatchUnit,
            materialDisplayName: e.materialBatchDisplayName,
            ncMaterialNo: e.ncMaterialNo,
            quantity: e.quantity,
            orderCode: e.orderCode,
            orderNo: e.orderNo,
            actualQuantity: 0,
          })
        })
        this.detailList = this.detailList.concat(tmpDetailList)
        console.log(tmpDetailList)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.aas {
  margin-left: 4%;
}
</style>
